import { Heading, Private } from '@core/ui';

import { useTranslation } from 'react-i18next';

export const UpNextWebinarHeader = ({ isVisible, title }: { isVisible: number; title: string; }) => {
    const { t } = useTranslation();

    return (
        <header>
            <span className="block uppercase">
                {t('WebinarUpNext.Heading.UpNext')}
            </span>
            <Heading variant="h3" styleAs="h2" classNames="text-primary">
                {title}
            </Heading>
            {!isVisible && (
                <span className="private">
                    <Private />
                    {t('Webinar.Visibility.Private')}
                </span>
            )}
        </header>
    );
};
